// extracted by mini-css-extract-plugin
export default {"inputBar":"chat-input_inputBar__HfzwL","aiInput":"chat-input_aiInput__fHO5Q","aiSendButton":"chat-input_aiSendButton__PmwuZ"};